import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, TextField, DialogContainer } from "react-md";
import { MSpinner } from "components/Shared";
import { getStatus, postStart } from "requests/PhoenixIntegration";
import responseHandler from "responseHandler";
import { rxEmailAddress, rxPhoneNumber } from "tools/regularExpressions";
import { EMAIL, TEXT } from "typeConstants/stringConstants";

const STATUS = {
  // ui states
  NONE: "NONE",
  FETCHING: "FETCHING",
  ERROR: "ERROR",
  SUBMITTED: "SUBMITTED",

  // response states
  RESPONSE_ERROR: "RESPONSE_ERROR",
  READY: "READY",
  INVALID: "INVALID",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
};

const PhoenixAtHome = ({ match: { params }, makeToast }) => {
  const mounted = useRef(true);

  const [email, setEmail] = useState();
  const [phone, setPhoneNumber] = useState();
  const [status, setStatus] = useState(STATUS.NONE);
  const [errorMessage, setErrorMessage] = useState("Error");
  const [warningVisible, setVisibile] = useState(true);
  const [typeInspectionModal, setInspectionModal] = useState("");
  const [inspectionModalVisible, setInspectionModalVisible] = useState(false);

  const fetchStatus = () => {
    setStatus(STATUS.FETCHING);

    getStatus(params.fileid, 
      (resp) => {
        setStatus(resp.Status);
      },
      () =>{
        setStatus(STATUS.ERROR);
        makeToast("Error");
      }, 
      mounted);        
  };

  useEffect(() => {
    if(status === STATUS.NONE)
      fetchStatus();

    return () => { mounted.current = false; };
  }, []);

  const submitRequest = () => {
    if (email && !rxEmailAddress.test(email)) {
      makeToast("Invalid Email Address.");
      return;
    } 
    if (phone && !rxPhoneNumber.test(phone)) {
      makeToast("Invalid Phone Number.");
      return;
    }

    setStatus(STATUS.FETCHING);

    postStart(params.fileid, email, phone,
      (resp) => {
        if(!resp.error) {
          setStatus(STATUS.SUBMITTED);
        }
        else {
          setErrorMessage(resp.message);
          setStatus(STATUS.RESPONSE_ERROR);
        }
      },
      () => {
        setStatus(STATUS.ERROR);
        makeToast("Error");
      }, 
      mounted); 
   
  };

  const hideDialogWarning = () => {
    setVisibile(false);
  };

  const createInspectionEmail = () => {
    setInspectionModal(EMAIL);
    setInspectionModalVisible(true);
  };

  const createInspectionText = () => {
    setInspectionModal(TEXT);
    setInspectionModalVisible(true);
  };

  return (
    <div className="policyholder-inspection-root">
      {(status === STATUS.NONE || status === STATUS.FETCHING) && <MSpinner />}
      {status === STATUS.ERROR && <h1>Request Error, please try again.</h1>}
      {status === STATUS.INVALID && <h1>This case is not compatible with the Mueller@Home Inspection workflow.</h1>}      
      {status === STATUS.SUBMITTED && <h1>Mueller@Home Inspection Successfully Created.</h1>}
      {status === STATUS.COMPLETED && <h1>This inspection already has a completed Mueller@Home Inspection.  Submitting this form will create a new one.</h1>}
      {status === STATUS.RESPONSE_ERROR && <h1>Error: {errorMessage}</h1>}
      {status === STATUS.IN_PROGRESS && 
        <DialogContainer 
        title={"!!! WARNING !!!"} 
        focusOnMount={false} 
        id={STATUS.IN_PROGRESS} 
        visible={warningVisible} 
        activeElementFocus={true}
        width={500} modal={true} 
        onHide={() => setVisibile(false)} 
        className="inspection-warning">
          <h6 className="warning-content">This inspection has an in-progress Mueller@Home Inspection.  Submitting this form will cancel the open inspection and create a new one.</h6>
          <Button raised primary onClick={hideDialogWarning}>Proceed with next inspection</Button> 
        </DialogContainer>}
      {(status === STATUS.READY || status === STATUS.IN_PROGRESS || status === STATUS.COMPLETED) &&
      <>
        <h3>Create a Mueller@Home Inspection</h3>
        <Button raised primary onClick={createInspectionEmail}>Email</Button>
        <Button raised primary onClick={createInspectionText}>Text Message</Button>
        {typeInspectionModal === EMAIL ? 
          (<DialogContainer 
            aria-label="Create a Mueller@Home Inspection Email"
            id="ph-email" 
            focusOnMount={false} 
            visible={inspectionModalVisible} 
            activeElementFocus={true} 
            width={500} modal={true} >
            <TextField
              id="ph-email-address"
              label="Enter Email:"
              maxLength={100}
              type="email"
              onChange={(val) => setEmail(val)}
              resize={{min:240, max:240}}
            />
            <Button primary raised onClick={submitRequest}>Submit</Button>
            <Button secondary flat onClick={() => {
              setInspectionModalVisible(false);
              setEmail();
              }}>Cancel</Button>
          </DialogContainer>) :
         ( <DialogContainer 
          aria-label="Create a Mueller@Home Inspection Text"
          id="ph-text" 
          focusOnMount={false} 
          visible={inspectionModalVisible} 
          activeElementFocus={true} 
          width={500} modal={true} >
          <TextField
            id="ph-phone-number"
            label="Enter 10 Digit Phone Number:"
            maxLength={10}
            type="text"
            onChange={(val) => setPhoneNumber(val)}
            resize={{min:240, max:240}}
          />
          <Button primary raised onClick={submitRequest}>Submit</Button>
          <Button secondary flat onClick={() => {
            setInspectionModalVisible(false);
            setPhoneNumber();
            }}>Cancel</Button>
        </DialogContainer>)
        }
       
      </>
      }      
    </div>
  );
};

PhoenixAtHome.propTypes = {
  match: PropTypes.object.isRequired,
  makeToast: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  makeToast: text => {
    responseHandler.customToast(text, "error", dispatch);
  }
});

export default connect(null, mapDispatchToProps)(PhoenixAtHome);